/**
 * After an import (CHAP-593): how many seed inboxes are now brothers on the
 * list, when any are. Seed and prepare refuse while that is above zero, so the
 * page says so at the import rather than at the refusal. A count, never which.
 */
import { seedInboxWarning } from './model.js';

export function SeedInboxNote({ count }: { count: number | null }) {
  const text = seedInboxWarning(count);
  if (!text) return null;
  return (
    <div role="status" className="mt-3 rounded border border-amber-200 bg-amber-50 p-2 text-sm text-amber-900 break-words">
      {text}
    </div>
  );
}
